/** Formatters for outbound contact analytics widgets. */

export function formatAnalyticsCount(n: number): string {
  const v = Math.max(0, Math.floor(n));
  return v.toLocaleString();
}

export function formatCallbacksPer1000(n: number): string {
  if (!Number.isFinite(n)) return '0';
  return n % 1 === 0 ? String(n) : n.toFixed(1);
}
